import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterState } from '../../types/Spreadsheet';

export type FilterChangeFunction = ( filters: FilterState ) => Promise<void> | void;

interface FilterChangeActionState {
  filterChangeFunction: FilterChangeFunction | null;
}

const initialState: FilterChangeActionState = {
  filterChangeFunction: null
};

export const filterChangeActionSlice = createSlice({
  name: 'filterChangeAction',
  initialState,
  reducers: {
    setFilterChangeFunction: ( state, action: PayloadAction<FilterChangeFunction | null> ) => {
      state.filterChangeFunction = action.payload;
    },
    resetFilterChangeFunction: ( state ) => {
      state.filterChangeFunction = null;
    }
  }
});

export const { setFilterChangeFunction, resetFilterChangeFunction } = filterChangeActionSlice.actions;

// Selector to get the filter change function
export const selectFilterChangeFunction = ( state: { spreadsheet: { filterChangeAction: FilterChangeActionState }}) => {
  return state.spreadsheet.filterChangeAction.filterChangeFunction;
};

export default filterChangeActionSlice.reducer;
